import * as _ from 'lodash';

import { Table } from './table';
import { TableColumn } from './column';
import { TableGroup } from './group';
import { TableItem } from './item';

import { TableItemObject } from '../table.interface';

export class TableRow {
  constructor(
    private _table: Table,
    private _columns: Array<TableColumn>,
    public index: number,
    private _rowData: any,
    private _group?: TableGroup
  ) {
    this._setItems();
    this._setAttributes();
  }

  public items: Array<TableItem> = [];

  private _selected = false;

  private _selectable = false;
  private _clickable = false;
  private _css_class: string = null;
  private _style: Object = {};

  private _has_input_with_error = false;

  public get selected(): boolean { return this._selected; }
  public set selected(selected: boolean) {
    this.setSelected(selected);
  }
  public setSelected(selected: boolean, ignore_event: boolean = false) {
    this._selected = selected;
    this.update();
    this._table.updateAllSelectedIcon();
    if (!ignore_event) { this._table.onSelectionChange.emit(this._table.getSelectedData(true)); }
  }

  public toggleSelect() {
    this.selected = !this.selected;
  }

  public get selectable(): boolean { return this._selectable; }

  public get clickable(): boolean { return this._clickable; }
  public onClick() {
    if (this.clickable) { this._table.onRowClick.emit(this.getData()); }
  }

  public get css_class(): string { return this._css_class; }

  public get style(): Object { return this._style; }

  public get has_input_with_error(): boolean { return this._has_input_with_error; }

  public getData(): any {
    return this._rowData;
  }

  public get data(): any {
    return this.getData();
  }

  public getDynamicData(): TableItemObject {
    const row_data = {};
    this.items.forEach((item) => {
      if (item.accessor) { row_data[item.accessor] = item; }
    });
    return row_data;
  }

  public setGroup(group: TableGroup) {
    this._group = group;
  }

  public update() {
    this.items.forEach((item) => item.update());
    this._setAttributes();
    if (this._group) { this._group.update(); }
  }

  private _setItems() {
    this.items = [];
    this._columns.forEach((column) => this.items.push(new TableItem(column, this._rowData, this)));
  }

  private _setAttributes() {
    this._selectable = this._table.getRowSelectable(this);
    this._clickable = this._table.getRowClickable(this);
    this._css_class = this._table.getRowCssClass(this);
    this._style = this._table.getRowStyle(this);
    this._has_input_with_error = this.items.map((item) => item.schema && !_.isEmpty(item.schema.errors)).filter((i) => i).length > 0;
  }
}
